"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var reactjs_popup_1 = __importDefault(require("reactjs-popup"));
require("reactjs-popup/dist/index.css");
var styled_components_1 = __importDefault(require("styled-components"));
var StyledPopup = styled_components_1.default(reactjs_popup_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  &-content[role='tooltip'] {\n    width: auto;\n    max-width: 780px;\n  }\n"], ["\n  &-content[role='tooltip'] {\n    width: auto;\n    max-width: 780px;\n  }\n"])));
var Tooltip = function (_a) {
    var content = _a.content, children = _a.children, arrow = _a.arrow, disabled = _a.disabled, position = _a.position, on = _a.on;
    return (react_1.default.createElement(StyledPopup, { on: on, trigger: function () { return children; }, closeOnDocumentClick: on === 'click', position: position, mouseEnterDelay: 1000, arrow: arrow, disabled: disabled }, content));
};
Tooltip.defaultProps = {
    arrow: true,
    disabled: false,
    position: 'top center',
    on: 'hover',
};
exports.default = Tooltip;
var templateObject_1;
